module.exports = __webpack_public_path__ + "img/global-2016-copenhagen.556d2fc4.jpg";